'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from 'react';
import PropTypes from 'prop-types';
import SettingsComponent from 'DesignManagerIde/components/settings/Settings';
/**
 * @class Container for IDE settings forms.
 */

export default class Settings extends Component {
  render() {
    const activeEditor = this.props.app && this.props.app.activeEditor || {};
    return /*#__PURE__*/_jsx(SettingsComponent, {
      activeEditor: activeEditor,
      settingsEditor: this.props.settingsEditor
    });
  }

}
Settings.propTypes = {
  app: PropTypes.object,
  settingsEditor: PropTypes.node
};